// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"549":"5b3808be","736":"7c977aa4"}[chunkId] + ".chunk.js";
};